import { Provider } from '@angular/core';
import { of } from 'rxjs';
import { WorkspaceService } from '../workspace.service';

function buildMockWorkspaceServiceDefaults(): Partial<WorkspaceService> {
  return {
    value$: of(undefined),
    workspace$: of(undefined),
    workspaces$: of([]),
    setWorkspace: jest.fn().mockResolvedValue(undefined),
    setWorkspaces: jest.fn(),
    reset: jest.fn().mockResolvedValue(undefined),
  };
}

export function MockWorkspaceServiceProvider(
  overrides: Partial<WorkspaceService> = {}
): Provider {
  return {
    provide: WorkspaceService,
    useValue: {
      ...buildMockWorkspaceServiceDefaults(),
      ...overrides,
    },
  };
}
